module.exports = __webpack_public_path__ + "822446f06a00defd4cf395484ce775b4.MP3";